import React from "react";

function SvgIcMapPoi018(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.462 22.95c4.958 2.58 7.737.103 7.853-.005a1.005 1.005 0 011.41.047.996.996 0 01-.034 1.405c-.105.1-1.86 1.73-4.95 1.73-1.452 0-3.196-.359-5.203-1.403-4.957-2.579-7.736-.102-7.854.005a1.007 1.007 0 01-1.41-.047.997.997 0 01.034-1.405c.155-.148 3.871-3.595 10.154-.327zM16 11.966c1.775 1.666 5.78 3.267 8.348 3.338-.066 1.896-1.233 4.388-3.143 6.792a4.757 4.757 0 01-.46.024c-1.025 0-2.156-.317-3.361-.944-2.076-1.08-4.137-1.628-6.124-1.63-.753 0-1.442.082-2.07.21-.953-1.632-1.493-3.18-1.536-4.452 2.567-.071 6.572-1.672 8.346-3.338zM23 8v5.052c-2.415-.482-5.345-1.786-6.817-3.127l-.184-.175c-1.4 1.401-4.479 2.798-6.999 3.302V8h14zm-5-4v2h-4V4h4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi018;
